var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ep-list" },
    [
      _vm.$slots.default
        ? [_vm._t("default")]
        : [
            _c("div", { staticClass: "ep-list-empty-text" }, [
              _vm._v(" 暂无数据 "),
            ]),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }